/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { GpsWaypoint } from "../skills/gps_waypoint";
import {
  WaypointFrameType_Enum,
  waypointFrameType_EnumFromJSON,
  waypointFrameType_EnumToJSON,
} from "../skills/waypoint_frame_type";

export const protobufPackage = "structure";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface Frame {
  type: WaypointFrameType_Enum;
  gpsOrigin: GpsWaypoint | undefined;
}

function createBaseFrame(): Frame {
  return { type: 0, gpsOrigin: undefined };
}

export const Frame = {
  encode(message: Frame, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.gpsOrigin !== undefined) {
      GpsWaypoint.encode(message.gpsOrigin, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Frame {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFrame();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.gpsOrigin = GpsWaypoint.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Frame {
    return {
      type: isSet(object.type) ? waypointFrameType_EnumFromJSON(object.type) : 0,
      gpsOrigin: isSet(object.gpsOrigin) ? GpsWaypoint.fromJSON(object.gpsOrigin) : undefined,
    };
  },

  toJSON(message: Frame): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = waypointFrameType_EnumToJSON(message.type);
    }
    if (message.gpsOrigin !== undefined) {
      obj.gpsOrigin = GpsWaypoint.toJSON(message.gpsOrigin);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Frame>, I>>(base?: I): Frame {
    return Frame.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Frame>, I>>(object: I): Frame {
    const message = createBaseFrame();
    message.type = object.type ?? 0;
    message.gpsOrigin = (object.gpsOrigin !== undefined && object.gpsOrigin !== null)
      ? GpsWaypoint.fromPartial(object.gpsOrigin)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
